<template>
  <!-- Con `buttonText`: botón con texto (cabecera del tutor). Sin él: ícono con tooltip. -->
  <v-btn
    v-if="buttonText"
    small
    depressed
    outlined
    color="secondary"
    :aria-label="label"
    @click.stop="copy"
  >
    <v-icon left small :color="copied ? 'success' : undefined">
      {{ copied ? 'mdi-check' : 'mdi-content-copy' }}
    </v-icon>
    {{ copied ? 'Copiado' : buttonText }}
  </v-btn>
  <v-tooltip v-else bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        :x-small="!large"
        :small="large"
        :aria-label="copied ? 'Copiado' : label"
        v-bind="attrs"
        v-on="on"
        @click.stop="copy"
      >
        <v-icon :x-small="!large" :small="large" :color="copied ? 'success' : undefined">
          {{ copied ? 'mdi-check' : 'mdi-content-copy' }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ copied ? 'Copiado' : label }}</span>
  </v-tooltip>
</template>

<script>
// Tiempo que se muestra el ✓ tras copiar antes de volver al ícono de copiar.
const COPIED_FEEDBACK_MS = 2000;

// Botón de copiar al portapapeles con confirmación visual. Si el navegador no permite
// copiar, emite `error` para que el contenedor avise.
export default {
  name: 'CopyButton',
  props: {
    text: { type: String, required: true },
    label: { type: String, default: 'Copiar' },
    buttonText: { type: String, default: '' },
    // Ícono un tamaño más grande (cabecera del tutor).
    large: { type: Boolean, default: false }
  },
  emits: ['copied', 'error'],
  data() {
    return { copied: false, timer: null };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.text);
        this.copied = true;
        this.$emit('copied');
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.copied = false;
        }, COPIED_FEEDBACK_MS);
      } catch (error) {
        this.$emit('error', error);
      }
    }
  }
};
</script>
